contaApp.controller('NoticeTableController', ['$scope', '$http', '$filter', function($scope, $http, $filter, $visits) {



}]);